module.exports = __webpack_public_path__ + "static/media/Search_SVG.5cd3b123.svg";